export const CALL_STATUS_EVENT = {
    QUEUED: "queued",
    RINGING: "ringing",
    IN_PROGRESS: "in-progress",
    CANCELED: "canceled",
    COMPLETED: "completed",
    NO_ANSWER: "no-answer",
    BUSY: "busy",
    FAILED: "failed",
} as const;

export type CallStatusEvent = (typeof CALL_STATUS_EVENT)[keyof typeof CALL_STATUS_EVENT];
